export enum UserOrganizationAction {
  Nothing = "Nothing",
  RemoveFromOrganization = "RemoveFromOrganization",
  DeleteUser = "DeleteUser",
}
